const KEY = "chessme.auth-return.v1";
let fallback: string | undefined;

/** Only known local destinations, without query strings, credentials or hosts. */
export function safeReturnPath(path: string): boolean {
  return /^\/(?:game|play\/slot)\/[A-Za-z0-9_-]{1,256}$/.test(path) ||
    /^\/(?:i|wait)\/[A-Za-z0-9_-]{1,128}(?:\.[A-Za-z0-9_-]{1,128}){0,3}$/.test(path) ||
    ["/my-games", "/settings", "/connect/telegram"].includes(path);
}
export function rememberReturn(path: string): void {
  if (!safeReturnPath(path)) return;
  fallback = path;
  try { sessionStorage.setItem(KEY, JSON.stringify({ path, expires: Date.now() + 30 * 60_000 })); } catch { /* current tab still works */ }
}
export function takeReturn(): string {
  let path = fallback;
  fallback = undefined;
  try {
    const saved = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (saved) {
      const value = JSON.parse(saved) as { path: string; expires: number };
      if (value.expires > Date.now() && safeReturnPath(value.path)) path = value.path;
    }
  } catch { /* storage may be disabled */ }
  return path && safeReturnPath(path) ? path : "/";
}
